export * from './loading-indicator.component';



// WEBPACK FOOTER //
// ./src/app/shared/loading-indicator/index.ts